import { Component, ElementRef, HostListener, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { ConstantsService } from 'app/services/constants-service';
import { environment } from 'environments/environment';
import { EntityOtherComponent } from 'app/entities/other/entity-other.component';


import { EntityOtherService } from 'app/entities/other/entity-other.service';
import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  templateUrl: './entity-surveys.component.html'
})

export class EntitySurveysComponent extends EntityOtherComponent implements OnInit {
  entityIdDetails: EntityIdDetails;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public entityDetailsService: EntityDetailsService,
    public domSanitizer: DomSanitizer,
    public entityOtherService: EntityOtherService) {
    super(route, router, domSanitizer, entityDetailsService, entityOtherService);
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
      this.entityDetailsService.entityDetailsUpdated.subscribe(
        (entityDetails) => {
          this.entityIdDetails = entityDetails;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/surveys/entity-surveys.component.ts